import { useUnreadActivityMonitor } from './unread-activity';

/**
 * Global monitors are hooks that generally are timer based.
 * Ex. an activity hook that checks for notifications every 60 seconds.
 */
export const useGlobalMonitors = () => {
  useUnreadActivityMonitor();
};
